import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageState from '../components/page/PageState';
import { useApp } from '../context/AppContext';
import RegulatoryAdminConsole from '../components/regulatory/RegulatoryAdminConsole';
import { canManageRegulatoryDatabase } from '../utils/regulatoryModel';

/**
 * Regulatory Database master (Sheet-2 rows 8 + 10). PRD s2.2: masters / config are platform_admin-only and every
 * mutation plus the admin reads are requireRole('platform_admin'). Gated here AND by the API; any other persona
 * gets no affordance and the console is never mounted, so no request is sent.
 * Commandment IV: AI drafts reach readers only after a different admin approves the exact draft.
 */
const RegulatoryDatabasePage = () => {
    const { user } = useApp();
    if (!canManageRegulatoryDatabase(user?.role)) {
        return <PageState status="empty" message="The Regulatory Database is not available for your role." />;
    }
    return (
        <PageShell>
            <PageHeader title="Regulatory Database" subtitle="Indian regulator documents: fetch or add them, draft a summary with AI, and publish it after a second admin reviews it" />
            <RegulatoryAdminConsole />
        </PageShell>
    );
};

export default RegulatoryDatabasePage;
